import { useMutation, UseMutationResult, MutationFunction, UseMutationOptions } from 'react-query';
import { IError } from 'dto/IError';

const useCustomMutation = <TData = any, TVariables = any>(
  mutationFn: MutationFunction<TData, TVariables>,
  options?: UseMutationOptions<TData, IError, TVariables>
): UseMutationResult<TData, IError, TVariables> => {
  return useMutation<TData, IError, TVariables>(mutationFn, options);
};
export default useCustomMutation;
